import axiosInstance from './axiosInstance';

export const addBOMPart = async (part_id, child_parts) => {
  try {
    const { data } = await axiosInstance.put(`/PartBom/${part_id}`, child_parts);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const saveKit = async (kit_id, bodyData) => {
  try {
    const { data } = await axiosInstance.put(`/Kit/${kit_id}`, bodyData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const deleteKitbyId = async (kit_id) => {
  try {
    const { data } = await axiosInstance.delete(`/Kit/${kit_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const getBOMsbyPart = async (part_id) => {
  try {
    const { data } = await axiosInstance.get(`/PartBom/Data/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getOpenKitbyPartId = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/Kit/Data/Part/${store_id}/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getKitbyId = async (kit_id) => {
  try {
    const { data } = await axiosInstance.get(`/Kit/Data/${kit_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getKitPartbyId = async (kit_id) => {
  try {
    const { data } = await axiosInstance.get(`/Kit/PartData/${kit_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getBOMbyPartStore = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/PartBom/Data/${store_id}/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getBOMAltbyPartStore = async (part_id, store_id) => {
  try {
    const { data } = await axiosInstance.get(`/PartBom/Data/Alternate/${store_id}/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getKitByFilter = async (store_id, company_id, status_id) => {
  try {
    const { data } = await axiosInstance.get(`/kit/DataStore/${store_id}`, { params: { companyId: company_id ?? undefined, statusId: status_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetPartUsedById = async (part_id) => {
  try {
    const { data } = await axiosInstance.get(`/partbom/parents/${part_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
